import qs from "query-string";

import {
  deleteCustomAllEventApi,
  deleteCustomEventInstanceApi,
  deleteThisAndFollowingCustomEventApi,
  deleteThisCustomEventApi,
  duplicateCustomEvent,
  getCustomEvent,
  getCustomEvents,
  getUndoDeleteCustomAllEvent,
  getUndoDeleteCustomEventInstance,
  getUndoDeleteThisAndFollowingCustomEvent,
  getUndoDeleteThisCustomEvent,
  postCustomEvent,
  putCustomEvent,
} from "@/apiv2/planner/calendar";
import { handleError } from "@/redux/utils/error";

import { STATUS } from "../../utils/constants";
import * as viewSelectors from "../views/views.selectors";

import * as calendarActions from "./calendar/calendar.actions";
import * as calendarSelectors from "./calendar/calendar.selectors";
import { DEFAULT_COLOUR_BY } from "./colourBy";
import { getCustomEventsWindow } from "./customEventsWindow";
import { ALL_DISPLAY_BACKEND_KEYS, PLANNER_DISPLAY_FIELDS } from "./displayFields";
import { DRAWER_MODE } from "./drawer/constants";
import * as drawerActions from "./drawer/drawer.actions";
import * as drawerSelectors from "./drawer/drawer.selectors";
import { handleEventError } from "./eventErrors";
import * as labelFilterActions from "./labelFilter/labelFilter.actions";
import * as orderActions from "./orders/orders.actions";
import * as orderSelectors from "./orders/orders.selectors";
import {
  MODULE,
  PATCH_CUSTOM_EVENT,
  RESET,
  RESET_CUSTOM_EVENT_TRANSACTION_STATE,
  SET_ACTIVE_CUSTOM_EVENT,
  SET_ACTIVE_ORDER,
  SET_ACTIVE_VIEW,
  SET_ASSIGN_LABEL_DROPDOWN_COORDINATES,
  SET_ASSIGN_USER_DROPDOWN_COORDINATES,
  SET_COLOUR_BY,
  SET_CONTEXT_MENU_ORDER_UID,
  SET_CREATE_CUSTOM_EVENT_STATUS,
  SET_CUSTOM_EVENT,
  SET_CUSTOM_EVENT_DATA_TO_UPDATE,
  SET_CUSTOM_EVENT_REMINDER,
  SET_CUSTOM_EVENT_REMINDERS,
  SET_CUSTOM_EVENTS,
  SET_DELETE_ALL_CUSTOM_EVENT_STATUS,
  SET_DELETE_CUSTOM_EVENT_INSTANCE_STATUS,
  SET_DELETE_THIS_AND_FOLLOWING_CUSTOM_EVENT_STATUS,
  SET_DELETE_THIS_CUSTOM_EVENT_STATUS,
  SET_DISPLAY_OPTION_TOGGLE,
  SET_DUPLICATE_EVENT_STATUS,
  SET_FETCH_CUSTOM_EVENT_STATUS,
  SET_FETCH_CUSTOM_EVENTS_STATUS,
  SET_IS_ASSIGN_LABEL_MENU_VISIBLE,
  SET_IS_ASSIGN_USER_MENU_VISIBLE,
  SET_IS_CUSTOM_ASSIGN_LABEL_MENU_VISIBLE,
  SET_IS_CUSTOM_ASSIGN_USER_MENU_VISIBLE,
  SET_IS_ORDER_COLUMN_COLLAPSE,
  SET_IS_ORDER_MODAL_OPEN,
  SET_IS_SETTINGS_MODAL_OPEN,
  SET_IS_SETTINGS_SAVING,
  SET_SETTINGS_END_TIME,
  SET_SETTINGS_START_TIME,
  SET_UNDO_DELETE_ALL_CUSTOM_EVENT_STATUS,
  SET_UNDO_DELETE_CUSTOM_EVENT_INSTANCE_STATUS,
  SET_UNDO_DELETE_THIS_AND_FOLLOWING_CUSTOM_EVENT_STATUS,
  SET_UNDO_DELETE_THIS_CUSTOM_EVENT_STATUS,
  SET_UPDATE_CUSTOM_EVENT_STATUS,
} from "./planner.actionTypes";
import * as selectors from "./planner.selectors";
import * as progressFilterActions from "./progressFilter/progressFilter.actions";
import { PROGRESS_VALUES } from "./progressFilter/progressFilter.constants";
import * as requiredDateFilterActions from "./requiredDateFilter/requiredDate.actions";
import * as scheduleStateFilterActions from "./scheduleStateFilter/scheduleStateFilter.actions";
import {
  LEGACY_IS_SCHEDULED_TO_STATE,
  SCHEDULE_STATE_ALL,
  SCHEDULE_STATE_VALUES,
} from "./scheduleStateFilter/scheduleStateFilter.constants";
import * as searchFilterActions from "./searchFilter/searchFilter.actions";
import * as statusFilterActions from "./statusFilter/statusFilter.actions";
import * as userFilterActions from "./userFilter/userFilter.actions";
import * as userFilterSelectors from "./userFilter/userFilter.selectors";

export const reset = () => (dispatch) => {
  dispatch({
    type: RESET,
  });
};

export const resetCustomEventTransactionState = () => (dispatch) => {
  dispatch({
    type: RESET_CUSTOM_EVENT_TRANSACTION_STATE,
  });
};

export const setActiveView = (data) => (dispatch) => {
  dispatch({
    type: SET_ACTIVE_VIEW,
    payload: data,
  });
};

export const setActiveOrder = (data) => (dispatch) => {
  dispatch({
    type: SET_ACTIVE_ORDER,
    payload: data,
  });
};

export const setContextMenuOrderUid = (uid) => (dispatch) => {
  dispatch({
    type: SET_CONTEXT_MENU_ORDER_UID,
    payload: uid,
  });
};

export const setIsAssignUserMenuVisible = (status) => (dispatch) => {
  dispatch({
    type: SET_IS_ASSIGN_USER_MENU_VISIBLE,
    payload: status,
  });
};

export const setIsAssignLabelMenuVisible = (status) => (dispatch) => {
  dispatch({
    type: SET_IS_ASSIGN_LABEL_MENU_VISIBLE,
    payload: status,
  });
};

export const setAssignUserDropdownCoordinates = (data) => (dispatch) => {
  dispatch({
    type: SET_ASSIGN_USER_DROPDOWN_COORDINATES,
    payload: data,
  });
};

export const setAssignLabelDropdownCoordinates = (data) => (dispatch) => {
  dispatch({
    type: SET_ASSIGN_LABEL_DROPDOWN_COORDINATES,
    payload: data,
  });
};

export const setIsOrderModalOpen = (data) => (dispatch) => {
  dispatch({
    type: SET_IS_ORDER_MODAL_OPEN,
    payload: data,
  });
};

export const setIsSettingsModalOpen = (data) => (dispatch) => {
  dispatch({
    type: SET_IS_SETTINGS_MODAL_OPEN,
    payload: data,
  });
};

export const setIsOrderColumnCollapse = (data) => (dispatch) => {
  dispatch({
    type: SET_IS_ORDER_COLUMN_COLLAPSE,
    payload: data,
  });
};

export const setSettingsStartTime = (data) => (dispatch) => {
  dispatch({
    type: SET_SETTINGS_START_TIME,
    payload: data,
  });
};

export const setSettingsEndTime = (data) => (dispatch) => {
  dispatch({
    type: SET_SETTINGS_END_TIME,
    payload: data,
  });
};

export const setIsSettingsSaving = (data) => (dispatch) => {
  dispatch({
    type: SET_IS_SETTINGS_SAVING,
    payload: data,
  });
};

export const showAssignUserMenu =
  ({ isVisible, event }) =>
  (dispatch) => {
    dispatch(setIsAssignUserMenuVisible(isVisible));

    dispatch(
      setAssignUserDropdownCoordinates({
        top: event.clientY,
        left: event.clientX,
      })
    );
  };

export const showAssignLabelMenu =
  ({ isVisible, event }) =>
  (dispatch) => {
    dispatch(setIsAssignLabelMenuVisible(isVisible));

    dispatch(
      setAssignLabelDropdownCoordinates({
        top: event.clientY,
        left: event.clientX,
      })
    );
  };

export const updateOrderCardAssignees = (values) => async (dispatch, getState) => {
  const state = getState();
  const { orderUid, assignees } = values;

  const orders = orderSelectors.getOrders(state);

  await dispatch(
    orderActions.setOrders(orders.map((o) => (o.uid === orderUid ? { ...o, assignees } : o)))
  );

  const schedules = calendarSelectors.getSchedules(state);

  dispatch(
    calendarActions.setOrderInCalendar(
      schedules.map((s) =>
        s.order.uid === orderUid
          ? {
              ...s,
              order: {
                ...s.order,
                assignees,
              },
            }
          : { ...s }
      )
    )
  );
};

export const assignUser =
  ({ orderUid, assignees }) =>
  async (dispatch) => {
    await dispatch(
      updateOrderCardAssignees({
        orderUid,
        assignees,
      })
    );
  };

export const updateOrderCardLabels = (values) => async (dispatch, getState) => {
  const state = getState();
  const { order } = values;

  const orders = orderSelectors.getOrders(state);

  await dispatch(
    orderActions.setOrders(
      orders.map((o) => (o.uid === order.uid ? { ...o, labels: order.labels } : { ...o }))
    )
  );

  const schedules = calendarSelectors.getSchedules(state);

  dispatch(
    calendarActions.setOrderInCalendar(
      schedules.map((s) =>
        s.order.uid === order.uid
          ? {
              ...s,
              order: {
                ...s.order,
                labels: order.labels,
              },
            }
          : { ...s }
      )
    )
  );
};

export const assignLabels =
  ({ order }) =>
  async (dispatch) => {
    await dispatch(
      updateOrderCardLabels({
        order: {
          uid: order.uid,
          labels: order.labels,
        },
      })
    );
  };

// Applies one parsed custom_filter to the board. Every branch below has an else that restores that
// key's own default, so calling this with an empty object IS the default board. resetViewToDefaults
// relies on that instead of repeating nine defaults that would drift apart.
const applyParsedCustomFilter = (parsedCustomFilter) => (dispatch, getState) => {
  const state = getState();

  if (typeof parsedCustomFilter.labels === "string") {
    parsedCustomFilter.labels = [parsedCustomFilter.labels];
  }

  if (typeof parsedCustomFilter.assignees === "string") {
    parsedCustomFilter.assignees = [parsedCustomFilter.assignees];
  }

  if (typeof parsedCustomFilter.resources === "string") {
    parsedCustomFilter.resources = [parsedCustomFilter.resources];
  }

  if (typeof parsedCustomFilter.statuses === "string") {
    parsedCustomFilter.statuses = [parsedCustomFilter.statuses];
  }

  if (parsedCustomFilter.assignees) {
    dispatch(
      userFilterActions.setSelectedUsers(
        parsedCustomFilter.assignees.map((a) =>
          Number.isNaN(parseInt(a)) ? "no_assignee" : parseInt(a)
        )
      )
    );
  } else {
    // Select every assignee, not an empty list. An empty selection is how the UI represents "the
    // user emptied this group", which the filter panel reads as "None" and which
    // hasEmptiedServerFilterGroup short-circuits into an empty board on the next fetch. An absent
    // key means "this view does not filter by assignee", so it has to land on all.
    dispatch(userFilterActions.selectAllUsers());
  }

  if (parsedCustomFilter.labels) {
    dispatch(labelFilterActions.setSelectedLabels(parsedCustomFilter.labels));
  } else {
    dispatch(labelFilterActions.selectAllLabels());
  }

  if (parsedCustomFilter.statuses) {
    dispatch(statusFilterActions.setSelectedStatuses(parsedCustomFilter.statuses));
  } else {
    // An absent key means the default set, so a view saved before the off-by-default statuses
    // existed now opens with them unticked, the same as a fresh board.
    dispatch(statusFilterActions.resetStatuses());
  }

  if (parsedCustomFilter.resources) {
    dispatch(
      calendarActions.setSelectedUsers(parsedCustomFilter.resources.map((r) => parseInt(r)))
    );
  } else {
    const users = userFilterSelectors.getUsers(state);
    dispatch(calendarActions.setSelectedUsers(users.map((u) => parseInt(u.id))));
  }

  if (parsedCustomFilter.search) {
    dispatch(searchFilterActions.setSearch(parsedCustomFilter.search));
  } else {
    dispatch(searchFilterActions.setSearch(""));
  }

  // The tab the view was saved on. Views saved before this shipped carry the old two-state
  // `is_scheduled` instead: "true" meant "has any entry", which is now Scheduled plus Partial, so
  // Scheduled is the closest single tab. schedule_state wins when a view somehow carries both.
  // Anything this build does not recognise falls back to All rather than reaching the server,
  // which returns 400 for any value outside the three states.
  const storedScheduleState =
    parsedCustomFilter.schedule_state ??
    LEGACY_IS_SCHEDULED_TO_STATE[parsedCustomFilter.is_scheduled];

  dispatch(
    scheduleStateFilterActions.setScheduleState(
      SCHEDULE_STATE_VALUES.includes(storedScheduleState) ? storedScheduleState : SCHEDULE_STATE_ALL
    )
  );

  // The same bracketing the picker applies: a view stored with plain dates must not send a
  // midnight end and drop the range's last day.
  dispatch(
    requiredDateFilterActions.setRequiredDates({
      startDate: parsedCustomFilter.required_start_date ?? null,
      endDate: parsedCustomFilter.required_end_date ?? null,
    })
  );

  if (parsedCustomFilter.calendar_view) {
    dispatch(calendarActions.setCalendarView(parsedCustomFilter.calendar_view));
  } else {
    dispatch(calendarActions.setCalendarView("day"));
  }

  // Mirrors the statuses/resources pattern: an absent key means the default, which for progress is
  // all three values rather than an empty board.
  if (parsedCustomFilter.progress) {
    dispatch(progressFilterActions.setSelectedProgress([].concat(parsedCustomFilter.progress)));
  } else {
    dispatch(progressFilterActions.setSelectedProgress([...PROGRESS_VALUES]));
  }

  dispatch(setColourBy(parsedCustomFilter.colour_by || DEFAULT_COLOUR_BY));

  // The filter drops a field this build no longer knows about, so a renamed field cannot poison
  // the whole set.
  dispatch(
    applyDisplayBackendKeys(
      parsedCustomFilter.display
        ? parsedCustomFilter.display.split(",").filter((k) => ALL_DISPLAY_BACKEND_KEYS.includes(k))
        : ALL_DISPLAY_BACKEND_KEYS
    )
  );
};

export const applyFilterFromUrl = () => (dispatch, getState) => {
  const selectedView = viewSelectors.getSelectedView(getState());

  // None carries no stored filter, so there is nothing to apply. Clearing the board when the user
  // picks None is resetViewToDefaults' job, not this one: this also runs on page load, where
  // wiping the freshly-fetched filter state would be wrong.
  if (selectedView && selectedView.name === "None") {
    return;
  }

  dispatch(applyParsedCustomFilter(selectedView ? qs.parse(selectedView.customFilter) : {}));
};

export const setActiveCustomEvent = (payload) => (dispatch) => {
  dispatch({
    type: SET_ACTIVE_CUSTOM_EVENT,
    payload,
  });
};

export const setIsCustomAssignLabelMenuVisible = (status) => (dispatch) => {
  dispatch({
    type: SET_IS_CUSTOM_ASSIGN_LABEL_MENU_VISIBLE,
    payload: status,
  });
};

export const setIsCustomAssignUserMenuVisible = (status) => (dispatch) => {
  dispatch({
    type: SET_IS_CUSTOM_ASSIGN_USER_MENU_VISIBLE,
    payload: status,
  });
};

export const showCustomAssignUserMenu =
  ({ isVisible, event }) =>
  (dispatch) => {
    dispatch(setIsCustomAssignUserMenuVisible(isVisible));

    dispatch(
      setAssignUserDropdownCoordinates({
        top: event.clientY,
        left: event.clientX,
      })
    );
  };

export const showCustomAssignLabelMenu =
  ({ isVisible, event }) =>
  (dispatch) => {
    dispatch(setIsCustomAssignLabelMenuVisible(isVisible));

    dispatch(
      setAssignLabelDropdownCoordinates({
        top: event.clientY,
        left: event.clientX,
      })
    );
  };

export const setFetchCustomEventsStatus = (payload) => (dispatch) => {
  dispatch({
    type: SET_FETCH_CUSTOM_EVENTS_STATUS,
    payload,
  });
};

export const setCustomEvents = (payload) => (dispatch) => {
  dispatch({
    type: SET_CUSTOM_EVENTS,
    payload,
  });
};

export const fetchCustomEvents = (params) => async (dispatch) => {
  try {
    dispatch(setFetchCustomEventsStatus(STATUS.PENDING));
    const response = await getCustomEvents(params)();
    dispatch(setCustomEvents(response.data));
    dispatch(setFetchCustomEventsStatus(STATUS.FULFILLED));
  } catch (error) {
    dispatch(setFetchCustomEventsStatus(STATUS.REJECTED));
    handleError(error, dispatch);
  }
};

export const setFetchCustomEventStatus = (payload) => (dispatch) => {
  dispatch({
    type: SET_FETCH_CUSTOM_EVENT_STATUS,
    payload,
  });
};

export const setCustomEvent = (payload) => (dispatch) => {
  dispatch({
    type: SET_CUSTOM_EVENT,
    payload,
  });
};

export const fetchCustomEvent = (uid) => async (dispatch) => {
  try {
    dispatch(setFetchCustomEventStatus(STATUS.PENDING));
    const response = await getCustomEvent(uid)();
    dispatch(setCustomEvent(response.data));
    dispatch(setFetchCustomEventStatus(STATUS.FULFILLED));
  } catch (error) {
    dispatch(setFetchCustomEventStatus(STATUS.REJECTED));
    handleError(error, dispatch);
  }
};

export const setCreateCustomEventStatus = (payload) => (dispatch) => {
  dispatch({
    type: SET_CREATE_CUSTOM_EVENT_STATUS,
    payload,
  });
};

export const createCustomEvent = (data) => async (dispatch) => {
  try {
    dispatch(setCreateCustomEventStatus(STATUS.PENDING));
    await postCustomEvent(data)();
    dispatch(setCreateCustomEventStatus(STATUS.FULFILLED));
  } catch (error) {
    dispatch(setCreateCustomEventStatus(STATUS.REJECTED));
    handleEventError(error, dispatch);
  }
};

export const setUpdateCustomEventStatus = (payload) => (dispatch) => {
  dispatch({
    type: SET_UPDATE_CUSTOM_EVENT_STATUS,
    payload,
  });
};

// `target` narrows the paint to one occurrence of a repeating event: { occurrenceDate, updateScope }.
export const patchCustomEvent =
  (uid, changes, target = {}) =>
  (dispatch) => {
    dispatch({
      type: PATCH_CUSTOM_EVENT,
      payload: { uid, changes, ...target },
    });
  };

// The board fields a user can flip from the drawer or the right-click menu. Painting them before
// the request lands is what makes "Mark complete" feel instant; a failure paints them back.
const OPTIMISTIC_FIELDS = ["isCompleted", "colour"];

// A scoped edit to a repeating event does not update the row we sent: "this event" saves a new
// EventInstance and "this and following" a new RecurringEvent, each with its own uid. The open
// drawer still holds the old one, so its live-row lookup misses and it keeps rendering the snapshot
// it opened with. Point it at the identity the server returned.
const retargetDrawerEvent =
  ({ previousUid, nextUid, occurrenceDate }) =>
  (dispatch, getState) => {
    const state = getState();
    const active = drawerSelectors.getActiveEvent(state);

    if (
      !nextUid ||
      !drawerSelectors.getIsOpen(state) ||
      drawerSelectors.getMode(state) !== DRAWER_MODE.EVENT ||
      active?.uid !== previousUid
    ) {
      return;
    }

    const row = selectors.getCustomEventOccurrence(state, nextUid, occurrenceDate);

    if (!row) {
      return;
    }

    // The drawer reads startTime/endTime, which only the board tile carries; a reloaded row has
    // startDatetime/endDatetime.
    dispatch(
      drawerActions.setActiveEvent({
        ...active,
        ...row,
        startTime: row.startDatetime,
        endTime: row.endDatetime,
      })
    );
  };

export const updateCustomEvent = (uid, data) => async (dispatch, getState) => {
  const current = (getState().getIn([MODULE, "customEvents"]) || []).find((e) => e.uid === uid);

  const optimistic = {};
  const rollback = {};
  OPTIMISTIC_FIELDS.forEach((field) => {
    if (current && data[field] !== undefined) {
      optimistic[field] = data[field];
      rollback[field] = current[field];
    }
  });

  const hasOptimistic = Object.keys(optimistic).length > 0;
  const patchTarget = { occurrenceDate: data.occurrenceDate, updateScope: data.updateScope };

  try {
    dispatch(setUpdateCustomEventStatus(STATUS.PENDING));
    if (hasOptimistic) {
      dispatch(patchCustomEvent(uid, optimistic, patchTarget));
    }
    const response = await putCustomEvent(uid, data)();

    // Reload so the board and the open drawer show what was actually saved. The optimistic patch
    // above only covers the two fields the board paints; everything else the drawer edits
    // (reminders, labels, assignees, the time range) would otherwise sit stale until a refresh.
    const fromDate = calendarSelectors.getFromDate(getState());
    const toDate = calendarSelectors.getToDate(getState());
    const reloaded = dispatch(fetchCustomEvents(getCustomEventsWindow({ fromDate, toDate })));

    // Ahead of the reload so the form modal still closes on the save, not a round trip later.
    dispatch(setUpdateCustomEventStatus(STATUS.FULFILLED));

    await reloaded;
    dispatch(
      retargetDrawerEvent({
        previousUid: uid,
        nextUid: response?.data?.uid,
        occurrenceDate: data.occurrenceDate,
      })
    );
  } catch (error) {
    if (hasOptimistic) {
      dispatch(patchCustomEvent(uid, rollback, patchTarget));
    }
    dispatch(setUpdateCustomEventStatus(STATUS.REJECTED));
    handleEventError(error, dispatch);
  }
};

export const setDuplicateEventStatus = (payload) => (dispatch) => {
  dispatch({
    type: SET_DUPLICATE_EVENT_STATUS,
    payload,
  });
};

export const duplicateEvent =
  (uid, params = {}) =>
  async (dispatch) => {
    try {
      dispatch(setDuplicateEventStatus(STATUS.PENDING));
      await duplicateCustomEvent(uid, params)();
      dispatch(setDuplicateEventStatus(STATUS.FULFILLED));
    } catch (error) {
      dispatch(setDuplicateEventStatus(STATUS.REJECTED));
      handleError(error, dispatch);
    }
  };

export const setDeleteCustomEventInstanceStatus = (payload) => (dispatch) => {
  dispatch({
    type: SET_DELETE_CUSTOM_EVENT_INSTANCE_STATUS,
    payload,
  });
};

export const deleteCustomEventInstance = (uid) => async (dispatch) => {
  try {
    dispatch(setDeleteCustomEventInstanceStatus(STATUS.PENDING));
    await deleteCustomEventInstanceApi(uid)();
    dispatch(setDeleteCustomEventInstanceStatus(STATUS.FULFILLED));
  } catch (error) {
    dispatch(setDeleteCustomEventInstanceStatus(STATUS.REJECTED));
    handleError(error, dispatch);
  }
};

export const setDeleteThisCustomEventStatus = (payload) => (dispatch) => {
  dispatch({
    type: SET_DELETE_THIS_CUSTOM_EVENT_STATUS,
    payload,
  });
};

export const deleteThisCustomEvent = (uid, date) => async (dispatch) => {
  try {
    dispatch(setDeleteThisCustomEventStatus(STATUS.PENDING));
    await deleteThisCustomEventApi(uid, date)();
    dispatch(setDeleteThisCustomEventStatus(STATUS.FULFILLED));
  } catch (error) {
    dispatch(setDeleteThisCustomEventStatus(STATUS.REJECTED));
    handleError(error, dispatch);
  }
};

export const setDeleteThisAndFollowingCustomEventStatus = (payload) => (dispatch) => {
  dispatch({
    type: SET_DELETE_THIS_AND_FOLLOWING_CUSTOM_EVENT_STATUS,
    payload,
  });
};

export const deleteThisAndFollowingCustomEvent = (uid, date) => async (dispatch) => {
  try {
    dispatch(setDeleteThisAndFollowingCustomEventStatus(STATUS.PENDING));
    await deleteThisAndFollowingCustomEventApi(uid, date)();
    dispatch(setDeleteThisAndFollowingCustomEventStatus(STATUS.FULFILLED));
  } catch (error) {
    dispatch(setDeleteThisAndFollowingCustomEventStatus(STATUS.REJECTED));
    handleError(error, dispatch);
  }
};

export const setDeleteAllCustomEventStatus = (payload) => (dispatch) => {
  dispatch({
    type: SET_DELETE_ALL_CUSTOM_EVENT_STATUS,
    payload,
  });
};

export const deleteCustomAllEvent = (uid) => async (dispatch) => {
  try {
    dispatch(setDeleteAllCustomEventStatus(STATUS.PENDING));
    await deleteCustomAllEventApi(uid)();
    dispatch(setDeleteAllCustomEventStatus(STATUS.FULFILLED));
  } catch (error) {
    dispatch(setDeleteAllCustomEventStatus(STATUS.REJECTED));
    handleError(error, dispatch);
  }
};

export const setUndoDeleteCustomEventInstanceStatus = (payload) => (dispatch) => {
  dispatch({
    type: SET_UNDO_DELETE_CUSTOM_EVENT_INSTANCE_STATUS,
    payload,
  });
};

export const undoDeleteCustomEventInstance = (uid) => async (dispatch) => {
  try {
    dispatch(setUndoDeleteCustomEventInstanceStatus(STATUS.PENDING));
    await getUndoDeleteCustomEventInstance(uid)();
    dispatch(setUndoDeleteCustomEventInstanceStatus(STATUS.FULFILLED));
  } catch (error) {
    dispatch(setUndoDeleteCustomEventInstanceStatus(STATUS.REJECTED));
    handleError(error, dispatch);
  }
};

export const setUndoDeleteThisCustomEventStatus = (payload) => (dispatch) => {
  dispatch({
    type: SET_UNDO_DELETE_THIS_CUSTOM_EVENT_STATUS,
    payload,
  });
};

export const undoDeleteThisCustomEvent = (uid, date) => async (dispatch) => {
  try {
    dispatch(setUndoDeleteThisCustomEventStatus(STATUS.PENDING));
    await getUndoDeleteThisCustomEvent(uid, date)();
    dispatch(setUndoDeleteThisCustomEventStatus(STATUS.FULFILLED));
  } catch (error) {
    dispatch(setUndoDeleteThisCustomEventStatus(STATUS.REJECTED));
    handleError(error, dispatch);
  }
};

export const setUndoDeleteThisAndFollowingCustomEventStatus = (payload) => (dispatch) => {
  dispatch({
    type: SET_UNDO_DELETE_THIS_AND_FOLLOWING_CUSTOM_EVENT_STATUS,
    payload,
  });
};

export const undoDeleteThisAndFollowingCustomEvent = (uid, date) => async (dispatch) => {
  try {
    dispatch(setUndoDeleteThisAndFollowingCustomEventStatus(STATUS.PENDING));
    await getUndoDeleteThisAndFollowingCustomEvent(uid, date)();
    dispatch(setUndoDeleteThisAndFollowingCustomEventStatus(STATUS.FULFILLED));
  } catch (error) {
    dispatch(setUndoDeleteThisAndFollowingCustomEventStatus(STATUS.REJECTED));
    handleError(error, dispatch);
  }
};

export const setUndoDeleteAllCustomEventStatus = (payload) => (dispatch) => {
  dispatch({
    type: SET_UNDO_DELETE_ALL_CUSTOM_EVENT_STATUS,
    payload,
  });
};

export const undoDeleteCustomAllEvent = (uid) => async (dispatch) => {
  try {
    dispatch(setUndoDeleteAllCustomEventStatus(STATUS.PENDING));
    await getUndoDeleteCustomAllEvent(uid)();
    dispatch(setUndoDeleteAllCustomEventStatus(STATUS.FULFILLED));
  } catch (error) {
    dispatch(setUndoDeleteAllCustomEventStatus(STATUS.REJECTED));
    handleError(error, dispatch);
  }
};

export const setCustomEventDataToUpdate = (payload) => (dispatch) => {
  dispatch({
    type: SET_CUSTOM_EVENT_DATA_TO_UPDATE,
    payload,
  });
};

export const setCustomEventReminders = (payload) => (dispatch) => {
  dispatch({
    type: SET_CUSTOM_EVENT_REMINDERS,
    payload,
  });
};

export const setCustomEventReminder = (payload) => (dispatch) => {
  dispatch({
    type: SET_CUSTOM_EVENT_REMINDER,
    payload,
  });
};

export const setDisplayOptionToggle = (option) => ({
  type: SET_DISPLAY_OPTION_TOGGLE,
  payload: option,
});

// Values are the three from ColourByControl's COLOUR_BY_OPTIONS: off, assignee, workflow_status.
export const setColourBy = (value) => (dispatch) => {
  dispatch({ type: SET_COLOUR_BY, payload: value });
};

// Converts the view's vocabulary into the runtime one. A saved view stores `display` as
// comma-joined backendKey strings; `settings.displayOptions` holds { key, title, isSelected }
// objects, keyed by the PLANNER_DISPLAY_* constant. Passing the raw strings through would leave
// DisplayControl reading undefined on every row: no crash, no failing test, a broken control.
export const applyDisplayBackendKeys = (backendKeys) => (dispatch) => {
  const selected = new Set(backendKeys);
  dispatch(
    setDisplayOptionToggle(
      PLANNER_DISPLAY_FIELDS.map((field) => ({
        key: field.key,
        title: field.title,
        isSelected: selected.has(field.backendKey),
      }))
    )
  );
};

// Selecting None means "the default board", so everything the previous view set is cleared, not
// just colour and display. An empty custom_filter makes every branch in applyParsedCustomFilter
// take its else, which is exactly the default board, so the defaults live in one place.
export const resetViewToDefaults = () => (dispatch) => {
  dispatch(applyParsedCustomFilter({}));
};

// The board must follow a selection that moved as a SIDE EFFECT (AC-6: being on a view means the
// board shows it): deleting the view you were in lands you on your default or None, and making
// another view your default moves you onto it. Mirrors ViewsControl's onSelect: None resets
// rather than rehydrates, because applyFilterFromUrl deliberately no-ops on None. Callers must
// only dispatch this when the selection actually changed — running it with an unchanged
// selection would re-apply the stored filter over the user's unsaved board tweaks (AC-14).
export const applySelectedViewToBoard = () => (dispatch, getState) => {
  const selectedView = viewSelectors.getSelectedView(getState());

  if (!selectedView || selectedView.name === "None") {
    dispatch(resetViewToDefaults());
    return;
  }

  dispatch(applyFilterFromUrl());
};

// Applying a view only rewrites filter state, so the board still holds whatever the previous fetch
// returned until this runs. Kept out of applySelectedViewToBoard so that thunk stays a pure state
// applier. The orders window resets first, or the rail paginates onto a stale offset.
export const refetchBoard = () => (dispatch) => {
  dispatch(orderActions.setOrders([]));
  dispatch(orderActions.setOffset(0));
  dispatch(orderActions.fetchOrders());
  dispatch(calendarActions.fetchSchedules());
};
